import { Col, Divider, Form, Input, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import {
  getCandidateCatalystInfoApi,
  updateCandidateCatalystInfoApi,
} from "../../api/candidate";
import Utils from "../../utils/Utils";
import WebUtils from "../../utils/WebUtils";
import Loader from "../Loader";

const userDetail = Utils.getUserDetail();

function CandidateDetails() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [edit, setEdit] = useState(false);
  const [form] = Form.useForm();

  const handleCancel = (e) => {
    e.preventDefault();
    setEdit(false);
    form.setFields([
      { name: "collegeName", errors: [] },
      { name: "yearsOfExperience", errors: [] },
      { name: "yearOfBirth", errors: [] },
    ]); // Clear all fields and validation messages
  };
  const handleSubmit = (value) => {
    const url = `${updateCandidateCatalystInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;
    setLoading(true);

    let reqBody = {
      collegeName: value.collegeName,
      yearsOfExperience: value.yearsOfExperience,
      yearOfBirth: value.yearOfBirth,
    };

    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        // console.log(result);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Candidate details updated successfully",
            placement: "topRight",
            showProgress: true,
          });
          form.setFields([
            { name: "collegeName", errors: [] },
            { name: "yearsOfExperience", errors: [] },
            { name: "yearOfBirth", errors: [] },
          ]);
          setLoading(false);
          setEdit(false);
          getCandidateDetails();
        } else if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "failure"
        ) {
          setLoading(false);
          notification.error({
            message: "Candidate details update failed",
            placement: "topRight",
            showProgress: true,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getCandidateDetails = () => {
    setLoading(true);
    const url = `${getCandidateCatalystInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&userRole=${userDetail?.userRole}`;

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setData(result.data.data);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getCandidateDetails();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div className="w-full lg:w-[78%] xl:w-[82%] pt-[.75rem]">
        <div>
          <p className="text-[#101828] font-semibold text-[1.25rem]">
            Candidate details
          </p>
          <p className="text-[#475467] w-[80%] text-[0.875rem]">
            Provide your personal and professional details
          </p>
        </div>
        <Divider />
        {data?.collegeName && (
          <Form
            form={form}
            onFinish={handleSubmit}
            initialValues={{
              collegeName: data && data.collegeName,
              yearsOfExperience: data?.yearsOfExperience || "",
              yearOfBirth: data?.yearOfBirth || "",
            }}
          >
            <Row className="mt-6 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#101828] font-semibold text-[0.95rem]">
                  College / University Name <span className="text-[#206DC5]">*</span>
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item
                  name="collegeName"
                  className=" p-0 m-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your college name!",
                    },
                  ]}
                >
                  <Input
                    className="w-full"
                    placeholder="College / University Name"
                    disabled={!edit}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className="mt-5 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#101828] font-semibold text-[0.95rem]">
                  Years of Experience <span className="text-[#206DC5]">*</span>
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item
                  name="yearsOfExperience"
                  className="p-0 m-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your years of experience!",
                    },
                  ]}
                >
                  <Input
                    className="w-full"
                    type="number"
                    placeholder="Years of Experience"
                    disabled={!edit}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className="mt-5 gap-y-2">
              <Col className="w-full lg:w-[33%]">
                <div className="text-[#101828] font-semibold text-[0.95rem]">
                  Year of Birth <span className="text-[#206DC5]">*</span>
                </div>
              </Col>
              <Col className="space-y-3 w-full lg:w-[50%]">
                <Form.Item
                  name="yearOfBirth"
                  className="p-0 m-0"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your year of birth!",
                    },
                  ]}
                >
                  <Input
                    className="w-full"
                    type="number"
                    placeholder="YYYY"
                    disabled={!edit}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="mt-5 gap-y-2">
              <Col className="w-full flex flex-col-reverse md:flex-row justify-end gap-2">
                {!edit ? (
                  <button
                    type="primary"
                    className="text-[0.85rem] w-full md:w-[110px] btn-orange py-[7px] px-3 text-white rounded-lg shadow-sm"
                    onClick={(e) => {
                      setEdit(true);
                      e.preventDefault();
                    }}
                  >
                    Edit
                  </button>
                ) : (
                  <>
                    <button
                      type="primary"
                      className="text-[0.85rem] w-full md:w-[110px] btn-orange py-[7px] px-3 text-white rounded-lg shadow-sm"
                      htmlType="submit"
                    >
                      Update
                    </button>
                    <button
                      type="default"
                      className="text-[0.85rem] w-full md:w-[110px] bg-white border border-[#D0D5DD] py-[7px] px-3 text-[#344054] rounded-lg shadow-sm"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </>
                )}
              </Col>
            </Row>
            <Divider />
          </Form>
        )}
      </div>
    </>
  );
}

export default CandidateDetails;
